import {
  format,
  parseISO,
  isBefore,
  isAfter,
  isEqual,
  isDate,
  startOfMonth,
  endOfMonth,
  subMonths,
  getYear,
  isValid,
  // subDays,
  // formatDistanceStrict,
  // lastDayOfMonth,
  // addMonths,
  // getMonth,
  // setMonth,
  // sub,
} from 'date-fns';
import axiosInstance from '@/utils/axios';
import API from '@/api';

//* Get 12 months date range with start/end date by year
const getMonthDates = (year = getYear(new Date())) => {
  return [...Array(12)].map((item, i) => {
    const start = format(startOfMonth(new Date(year, i, 1)), 'yyyy-MM-dd');
    const end = format(endOfMonth(new Date(year, i, 1)), 'yyyy-MM-dd');
    const month = format(parseISO(start), 'LLLL');
    return {
      month,
      start,
      end,
    };
  });
};

//* Get shot data for last 6 months
const getLastSixMonthsData = async (dateData, clubhouseUUID) => {
  if (!dateData) return [];
  const data = await Promise.all(
    dateData?.map(async (item) => {
      const fromDate = item.start;
      const toDate = item.end;
      const response = await axiosInstance.get(
        `/clubhouse/${clubhouseUUID}/metrics/shots?fromDate=${fromDate || ''}&toDate=${
          toDate || ''
        }`
      );
      return { ...item, ...response.data };
    })
  );
  // console.log('data:', data);

  if (data?.length) {
    return data.reverse();
  }
  return [];
};

//* Get shot data for each month
const getMonthsData = async (monthArr, clubhouseUUID, singleSim = false, licenseID = null) => {
  if (!monthArr) return [];
  const data = await Promise.all(
    monthArr?.map(async (item) => {
      const fromDate = item.start;
      const toDate = item.end;
      const urlShotsUsage = `/clubhouse/${clubhouseUUID}/metrics/${
        singleSim ? 'simulators/' : ''
      }shots${singleSim ? `/${licenseID}` : ''}?fromDate=${fromDate || ''}&toDate=${toDate || ''}`;

      const urlUsage = `/clubhouse/${clubhouseUUID}/metrics/simulators/usage${
        singleSim ? `/${licenseID}` : ''
      }?fromDate=${fromDate || ''}&toDate=${toDate || ''}`;

      // const payload = {
      //   clubID: clubhouseUUID,
      //   fromDate,
      //   toDate,
      // };

      const responseShotsUsage = await axiosInstance.get(urlShotsUsage);
      const responseTimeUsage = await axiosInstance.get(urlUsage);
      // const responseTimeUsage = await API.clubhouses.clubhouseUsageStats(payload);
      if (!responseTimeUsage?.data) {
        return;
      }
      return { ...item, ...responseShotsUsage.data, usage: responseTimeUsage?.data?.usage };
    })
  );

  if (data?.length) {
    return data.reverse();
  }
  return [];
};

//* Get last 6 months date range with start/end date starting from today or custom date
const getLastSixMonths = (today = new Date(), clubhouseUUID) => {
  if (!isDate(today)) {
    today = parseISO(today);
  }

  const lastSix = [...Array(6)].map((_, i) => {
    const start = format(startOfMonth(subMonths(today, i)), 'yyyy-MM-dd');
    const end = format(endOfMonth(subMonths(today, i)), 'yyyy-MM-dd');
    const month = format(parseISO(start), 'LLL');
    const year = format(parseISO(start), 'yyyy');
    return {
      month,
      year,
      start,
      end,
    };
  });
  // console.log('lastSix:', lastSix);

  return lastSix;
};

//* Get last n months date range with start/end date starting from today or custom date
const getLastNMonths = (today = new Date(), numberOfMonths = 6) => {
  if (!isDate(today)) {
    today = parseISO(today);
  }

  const monthRangeData = [...Array(numberOfMonths)].map((_, i) => {
    const start = format(startOfMonth(subMonths(today, i)), 'yyyy-MM-dd');
    const end = format(endOfMonth(subMonths(today, i)), 'yyyy-MM-dd');
    const month = format(parseISO(start), 'LLL');
    const year = format(parseISO(start), 'yyyy');
    return {
      month,
      year,
      start,
      end,
    };
  });
  // console.log('monthRangeData:', monthRangeData);

  return monthRangeData;
};

const isSameOrBefore = (date1, date2) => {
  return isBefore(parseISO(date1), parseISO(date2)) || isEqual(parseISO(date1), parseISO(date2));
};

const isSameOrAfter = (date1, date2) => {
  return isAfter(parseISO(date1), parseISO(date2)) || isEqual(parseISO(date1), parseISO(date2));
};

const isBetween = (startDate, endDate, testDate) => {
  const parsedDateObject = parseDateIfNeeded(testDate);
  const isAfterStart = isAfter(parsedDateObject, parseISO(startDate));
  const isBeforeEnd = isBefore(parsedDateObject, parseISO(endDate));
  return isAfterStart && isBeforeEnd;
};

// Helper function to safely parse a date
const parseDateIfNeeded = (dateInput) => {
  // If it's already a valid Date object, return it
  if (dateInput instanceof Date && !isNaN(dateInput)) {
    return dateInput;
  }

  // If it's a string, try to parse it
  if (typeof dateInput === 'string') {
    const parsed = parseISO(dateInput);
    // Check if the parsed date is valid
    if (isValid(parsed)) {
      return parsed;
    }
  }

  // Return null or throw error if date is invalid
  throw new Error('Invalid date input');
  // return null;
};

export {
  getMonthDates,
  getLastSixMonths,
  getLastSixMonthsData,
  getMonthsData,
  getLastNMonths,
  isSameOrBefore,
  isSameOrAfter,
  isBetween,
  parseDateIfNeeded,
};
